<template>
  <Container
    title="加油统计"
    :returnBtn="false"
    :addBtn="false"
  >
    <div style="padding: 20px;">
      <!-- 时间选择器 -->
      <el-form :inline="true" class="demo-form-inline" style="margin-bottom: 20px;">
        <el-form-item label="选择日期">
          <el-date-picker
            v-model="selectedDate"
            type="date"
            placeholder="选择日期"
            format="YYYY年MM月DD日"
            value-format="YYYY-MM-DD"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchData">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportExcel">导出Excel</el-button>
        </el-form-item>
      </el-form>

      <!-- 统计概览 -->
      <div class="stats-overview">
        <el-card shadow="hover" class="stats-card">
          <template #header>
            <div class="card-header">
              <span>统计概览</span>
            </div>
          </template>
          <div class="stats-grid">
            <div class="stats-item">
              <div class="stats-label">加油总金额</div>
              <div class="stats-value">{{ formatMoneyValue(statisticsData.totalAmount) }}</div>
            </div>
            <div class="stats-item">
              <div class="stats-label">加油总升数</div>
              <div class="stats-value">{{ formatLiterValue(statisticsData.totalLiters) }}</div>
            </div>
            <div class="stats-item">
              <div class="stats-label">加油笔数</div>
              <div class="stats-value">{{ statisticsData.totalCount || 0 }}</div>
            </div>
            <div class="stats-item">
              <div class="stats-label">平均金额</div>
              <div class="stats-value">{{ formatMoneyValue(statisticsData.totalAmount / (statisticsData.totalCount || 1)) }}</div>
            </div>
          </div>
        </el-card>
      </div>

      <!-- 加油员统计 -->
      <div class="attendant-stats" style="margin-top: 20px;">
        <el-card shadow="hover" class="stats-card">
          <template #header>
            <div class="card-header">
              <span>加油员统计</span>
            </div>
          </template>
          <div style="margin-bottom: 20px;">
            <div ref="attendantChart" style="width: 100%; height: 400px;"></div>
          </div>
          <el-table :data="attendantStats" style="width: 100%">
            <el-table-column prop="attendantId" label="加油员ID" width="120" align="center" />
            <el-table-column label="加油员名称" width="150" align="center">
              <template #default="scope">
                {{ getAttendantName(scope.row.attendantId) }}
              </template>
            </el-table-column>
            <el-table-column prop="count" label="加油笔数" width="120" align="center" />
            <el-table-column label="加油总金额" width="180" align="center">
              <template #default="scope">
                {{ formatMoneyValue(scope.row.amount) }}
              </template>
            </el-table-column>
            <el-table-column label="加油总升数" align="center">
              <template #default="scope">
                {{ formatLiterValue(scope.row.liters) }}
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>

      <!-- 加油明细 -->
      <div class="oil-detail" style="margin-top: 20px;">
        <el-card shadow="hover" class="stats-card">
          <template #header>
            <div class="card-header">
              <span>加油明细</span>
            </div>
          </template>
          <el-table :data="oilDetails" style="width: 100%">
            <el-table-column prop="id" label="ID" width="80" />
            <el-table-column prop="name" label="用户姓名" width="120" />
            <el-table-column prop="phone" label="手机号" width="150" />
            <el-table-column label="加油金额" width="120">
              <template #default="scope">
                {{ formatMoneyValue(scope.row.money) }}
              </template>
            </el-table-column>
            <el-table-column label="加油升数" width="120">
              <template #default="scope">
                {{ formatLiterValue(scope.row.oilsum) }}
              </template>
            </el-table-column>
            <el-table-column label="油价" width="120">
              <template #default="scope">
                {{ formatPriceValue(scope.row.oilprice) }}
              </template>
            </el-table-column>
            <el-table-column prop="yuser_id" label="加油员ID" width="100" />
            <el-table-column label="加油时间" width="180">
              <template #default="scope">
                {{ formatDateTimeValue(scope.row.time) }}
              </template>
            </el-table-column>
            <el-table-column prop="note" label="备注" />
          </el-table>
          <el-pagination
            v-if="total > 0"
            style="margin-top: 20px; text-align: right;"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          />
        </el-card>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../../../components/container/Container";
import * as echarts from "echarts";

export default {
  components: {
    Container
  },
  data() {
    return {
      selectedDate: '',
      statisticsData: {
        totalAmount: 0,
        totalLiters: 0,
        totalCount: 0
      },
      attendantStats: [],
      oilDetails: [],
      total: 0,
      page: 1,
      pageSize: 10,
      userList: []
    };
  },
  mounted() {
    // 默认选择当天
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    this.selectedDate = `${year}-${month}-${day}`;
    this.getUserList();
    this.searchData();
  },
  methods: {
    async getUserList() {
      try {
        const response = await this.$api.bgyx.getdata('yuser', {});
        if (response.success) {
          this.userList = response.data || [];
          console.log(8888,response)
        }
      } catch (error) {
        console.error('获取用户列表失败:', error);
      }
    },
    getAttendantName(attendantId) {
      if (attendantId === 0) {
        return '系统加油';
      }
      // 从用户列表中查找加油员姓名
      const user = this.userList.find(u => u.id === attendantId);
      return user ? user.name : `加油员${attendantId}`;
    },
    async searchData() {
      try {
        const date = this.selectedDate || new Date().toISOString().split('T')[0];
        
        // 转换日期为时间戳（当天开始和结束）
        const startTime = new Date(date).getTime();
        const endTime = startTime + 24 * 60 * 60 * 1000 - 1;
        
        // 获取统计数据
        const statsResponse = await this.$api.bgyx.getOilStatistics({
          startTime,
          endTime
        });
        
        if (statsResponse.success) {
          this.statisticsData = {
            totalAmount: parseFloat(statsResponse.data.totalAmount) || 0,
            totalLiters: parseFloat(statsResponse.data.totalLiters) || 0,
            totalCount: statsResponse.data.details ? statsResponse.data.details.length : 0
          };
          this.attendantStats = statsResponse.data.attendantStats || [];
          this.oilDetails = statsResponse.data.details || [];
          this.total = statsResponse.data.details ? statsResponse.data.details.length : 0;
          
          // 渲染加油员统计图表
          this.renderAttendantChart();
        }
      } catch (error) {
        console.error('获取加油统计数据失败:', error);
        this.$message.error('获取数据失败');
      }
    },
    renderAttendantChart() {
      if (!this.$refs.attendantChart) return;
      
      const chart = echarts.init(this.$refs.attendantChart);
      
      const attendantNames = this.attendantStats.map(item => this.getAttendantName(item.attendantId));
      const amounts = this.attendantStats.map(item => (item.amount) / 100); // 转换为元
      
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            return params[0].name + '<br/>加油总金额: ¥' + params[0].value.toFixed(2);
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: attendantNames,
          axisLabel: {
            interval: 0,
            rotate: 30
          }
        },
        yAxis: {
          type: 'value',
          name: '金额 (元)',
          axisLabel: {
            formatter: '¥{value}'
          }
        },
        series: [
          {
            name: '加油总金额',
            type: 'bar',
            data: amounts,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#83bff6' },
                { offset: 0.5, color: '#188df0' },
                { offset: 1, color: '#188df0' }
              ])
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#2378f7' },
                  { offset: 0.7, color: '#2378f7' },
                  { offset: 1, color: '#83bff6' }
                ])
              }
            },
            label: {
              show: true,
              position: 'top',
              formatter: '¥{c}'
            }
          }
        ]
      };
      
      chart.setOption(option);
      
      // 响应式调整
      window.addEventListener('resize', function() {
        chart.resize();
      });
    },
    async exportExcel() {
      try {
        const date = this.selectedDate || new Date().toISOString().split('T')[0];
        
        // 转换日期为时间戳
        const startTime = new Date(date).getTime();
        const endTime = startTime + 24 * 60 * 60 * 1000 - 1;
        
        const response = await this.$api.bgyx.exportOilExcel({
          startTime,
          endTime
        });
        
        if (response) {
          // 处理Excel下载
          const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `加油统计_${this.selectedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        }
      } catch (error) {
        console.error('导出Excel失败:', error);
        this.$message.error('导出失败');
      }
    },
    formatMoneyValue(value) {
      if (value === null || value === undefined || isNaN(value)) {
        return '¥0.00';
      }
      return `¥${(parseFloat(value) / 100).toFixed(2)}`;
    },
    formatLiterValue(value) {
      if (value === null || value === undefined || isNaN(value)) {
        return '0.00 L';
      }
      return `${parseFloat(value).toFixed(2)} L`;
    },
    formatPriceValue(value) {
      if (value === null || value === undefined || isNaN(value)) {
        return '¥0.00/L';
      }
      return `¥${(parseFloat(value) / 100).toFixed(2)}/L`;
    },
    formatDateTimeValue(value) {
      if (!value) return '-';
      return new Date(parseFloat(value)).toLocaleString('zh-CN');
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.searchData();
    }
  }
};
</script>

<style scoped>
.stats-overview {
  margin-bottom: 20px;
}

.stats-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 10px;
}

.stats-item {
  text-align: center;
  padding: 20px;
  background-color: #f5f7fa;
  border-radius: 8px;
}

.stats-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
}

.stats-value {
  font-size: 24px;
  font-weight: bold;
  color: #409eff;
}

.charts-container {
  margin-bottom: 20px;
}

.oil-detail {
  margin-bottom: 20px;
}
</style>